// Помощни функции за форматиране в човешкия изглед на одит лога.
// Валутата е единна — ЕВРО. Показваме сумите като "12.00 €".

/** Форматира число като сума в евро: 12 → "12.00 €". */
export function eur(value: unknown): string {
  const n = toNumber(value);
  if (n === null) return "—";
  return `${n.toFixed(2)} €`;
}

/** Форматира количество — цели числа без дроб, дробните без излишни нули. */
export function qty(value: unknown): string {
  const n = toNumber(value);
  if (n === null) return "—";
  if (Number.isInteger(n)) return String(n);
  return String(parseFloat(n.toFixed(3)));
}

/** Форматира процент: 10 → "10%"; отрицателен (надбавка) → "+10%". */
export function pct(value: unknown): string {
  const n = toNumber(value);
  if (n === null) return "—";
  if (n < 0) return `+${parseFloat(Math.abs(n).toFixed(2))}%`;
  return `${parseFloat(n.toFixed(2))}%`;
}

/** Безопасно превръща низ/число/Decimal-низ в число; иначе null. */
export function toNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === "") return null;
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}

/** Превежда item_names речник ({lang: name, bg, en}) според текущия език. */
export function pickItemName(
  itemNames: unknown,
  lang: string,
): string | null {
  if (!itemNames || typeof itemNames !== "object") return null;
  const dict = itemNames as Record<string, unknown>;
  const v = dict[lang] ?? dict.bg ?? dict.en;
  return typeof v === "string" && v.trim() ? v : null;
}
